import { render } from "./ListClientSkuMasters.vue?vue&type=template&id=70d44ed2"
import script from "./ListClientSkuMasters.vue?vue&type=script&lang=js"
export * from "./ListClientSkuMasters.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__